import { AppService } from '../app.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NutritionClassificationModel } from '../models/nutritionClassification.model';

@Injectable()
export class NutritionClassificationService extends AppService<NutritionClassificationModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getAll(companyId: string, daysOfResume: number) {
    const filters = `localClienteId=${companyId}&daysOfResume=${daysOfResume}`;

    const result = await this.getAllAsync(`ClassificacaoNutricional?` + filters);
    return result;
  }

  async get(dependentId: string, daysOfResume: number) {
    const filters = `daysOfResume=${daysOfResume}`;

    const result = await this.getAllAsync(`ClassificacaoNutricional/${dependentId}?` + filters);
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/nutrition-classification.service.ts